<form class="form-horizontal" [formGroup]="companyAddressInformationForm">
  <accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-map-marker'></i> Información de Ubicación
      </span>

      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Local</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="localType"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="localType" [items]="localTypes" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Pais</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="country"></span>
          </label>
          <ng-select formControlName="country" [items]="nationalities" bindLabel="country" bindValue="code" (change)="changeCountry($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Departamento</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="deparment"></span>
          </label>
          <ng-select formControlName="deparment" [items]="departments" bindLabel="name" bindValue="region" (change)="changeDepartment($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Ciudad</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="city"></span>
          </label>
          <ng-select formControlName="city" [items]="cities" bindLabel="name" bindValue="cityCode" (change)="changeCity($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Colonia</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="neighborhood"></span>
          </label>
          <ng-select formControlName="neighborhood" [items]="neighborhoods" bindLabel="name" bindValue="code" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 1</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="street"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street" [ngClass]="companyAddressInformationForm.controls.street.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 2</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="street2"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street2" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 3</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="street3"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street3" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 4</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="street4"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street4" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 5</b>
          <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="street5"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street5" [readonly]="readonly">
        </div>
      </div>

    </accordion-group>
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-phone'></i> Información de Teléfono
      </span>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Telefono</b>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" value="Empresa" disabled >
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-8">
          <label class="col-form-label"><b>Teléfono</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="companyPhone"></span>
          </label>
          <input type="text" class="form-control" formControlName="companyPhone" [ngClass]="companyAddressInformationForm.controls.companyPhone.errors ? 'is-invalid' : 'is-valid'" [mask]="currentMask" [showMaskTyped]="true" [readonly]="readonly">
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label"><b>Extensión</b>
            <span appRequiredAsterisk [formGroup]="companyAddressInformationForm" controlName="companyExtension"></span>
          </label>
          <input type="text" class="form-control" formControlName="companyExtension" [readonly]="readonly">
        </div>
      </div>
    </accordion-group>
  </accordion>
</form>
